import { useNavigate } from "react-router-dom";
import { Button, useTheme, Box } from "@mui/material";
import { Avatar, Menu, MenuItem, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

export default function RoutesBtn({ nav }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState(10);

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
      console.log("Decoded Token:", decodedToken);
      setUserRole(decodedToken.role);
    }
  }, [token]);

  const handleContactUsClick = () => {
    navigate("/contact-us");
  };

  const handleLoginLogoutClick = () => {
    if (token) {
      localStorage.removeItem("token");
      localStorage.removeItem("studentdata");
      localStorage.removeItem("userId");
      navigate("/");
    } else {
      navigate("/admin/login");
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    navigate("/admin/portal");
    if (userRole < 2) {
      navigate("/admin/portal");
    } else {
      navigate("/parents/portal");
    }
    handleMenuClose();
  };

  return (
    <Box display="flex" flexDirection={nav ? "row" : "column"} gap={2}>
      <Button
        size={nav ? "medium" : "large"}
        fullWidth={!nav}
        variant="contained"
        onClick={handleContactUsClick}
        sx={{ color: theme.palette.common.white }}
      >
        Contact Us
      </Button>
      {/* {!token && (
        <Button
          size={nav ? "medium" : "large"}
          fullWidth={!nav}
          variant="outlined"
          onClick={handleLoginLogoutClick}
          // sx={{ color: theme.palette.common.white }}
        >
          Log in
        </Button>
      )} */}
    </Box>
  );
}
